export const menu = [
    {
        "type": 'header',
        "href": '#',
        "icon": '',
        "entity": '',
        "label": 'Pagine'
    },
    {
        "type": 'item',
        "href": '/',
        "icon": 'home',
        "entity": '',
        "label": 'Dashboard'
    },

    {
        "type": 'header',
        "href": '#',
        "icon": '',
        "entity": '',
        "label": 'Questionari'
    },
    {
        "type": 'item',
        "href": '/entity/gyv_apartment_assessment_step',
        "icon": 'fa-house-user',
        "entity": 'gyv_apartment_assessment_step',
        "label": 'Appartamenti'
    },
    {
        "type": 'item',
        "href": '/entity/gyv_bathroom_assessment_step',
        "icon": 'fa-shower',
        "entity": 'gyv_bathroom_assessment_step',
        "label": 'Bagni'
    },
    {
        "type": 'header',
        "href": '#',
        "icon": '',
        "entity": '',
        "label": 'Preventivi'
    },
    {
        "type": 'item',
        "href": '/entity/quotation',
        "icon": 'fa-sheet-plastic',
        "entity": 'quotation',
        "label": 'Preventivi'
    },
    {
        "type": 'header',
        "href": '#',
        "icon": '',
        "entity": '',
        "label": 'Media'
    },
    {
        "type": 'item',
        "href": '/entity/media',
        "icon": 'fa-photo-film',
        "entity": 'media',
        "label": 'Media'
    },
    {
        "type": 'header',
        "href": '#',
        "icon": '',
        "entity": '',
        "label": 'Blog'
    },
    {
        "type": 'item',
        "href": '/entity/news',
        "icon": 'fa-file',
        "entity": 'news',
        "label": 'News'
    },
    {
        "type": 'item',
        "href": '/entity/news_category',
        "icon": 'fa-copy',
        "entity": 'news_category',
        "label": 'Categorie News'
    },
    {
        "type": 'header',
        "href": '#',
        "icon": '',
        "entity": '',
        "label": 'Configurazioni'
    },
    {
        "type": 'item',
        "href": '/entity/config',
        "icon": 'sliders',
        "entity": 'config',
        "label": 'Parametri App'
    },
    {
        "type": 'item',
        "href": '/entity/notify_device',
        "icon": 'mobile',
        "entity": 'notify_device',
        "label": 'Dispositivi Notificabili'
    },
    {
        "type": 'header',
        "href": '#',
        "icon": '',
        "entity": '',
        "label": 'Utenti App'
    },
    {
        "type": 'item',
        "href": '/entity/user',
        "icon": 'user',
        "entity": 'user',
        "label": 'Utenti'
    },
    {
        "type": 'item',
        "href": '/entity/gyv_referral_code_stats',
        "icon": 'barcode',
        "entity": 'referral_code',
        "label": 'Codici Referral'
    },
    {
        "type": 'header',
        "href": '#',
        "icon": '',
        "entity": '',
        "label": 'Utente'
    },
    {
        "type": 'item',
        "href": '/settings',
        "icon": 'user-gear',
        "entity": '',
        "label": 'Profilo'
    },
    {
        "type": 'folder',
        "href": '#',
        "icon": 'cogs',
        "entity": '',
        "label": 'Impostazioni',
        "items": [
            {
                "type": 'item',
                "href": '/entity/config',
                "entity": 'config',
                "label": 'Configurazione App'
            },
            {
                "type": 'item',
                "href": '/entity/user_group',
                "entity": 'user_group',
                "label": 'Gruppi'
            },
            {
                "type": 'item',
                "href": '/entity/user_entity_saved_filters',
                "entity": 'user_entity_saved_filters',
                "label": 'Filtri salvati'
            },
            {
                "type": 'item',
                "href": '/entity/user_entity_preferences',
                "entity": 'user_entity_preferences',
                "label": 'Preferenze entità'
            },
        ]
    },
    {
        "type": 'item',
        "href": '/logout',
        "icon": 'arrow-right-from-bracket',
        "entity": '',
        "label": 'Logout'
    }
]